/*
 *   File : permissions.js
 *   Author : https://evoqins.com
 *   Description : Access and permission tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useState } from 'react';

//Custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { SecondaryButton, TextButton } from '../../../Components/Buttons';
import { Icon } from '../../../Components/Icon';

const ACCESS_DATA = [
    {
        id: 1,
        access: "Dashboard"
    },
    {
        id: 2,
        access: "Customers"
    },
    {
        id: 3,
        access: "Manage baskets"
    },
    {
        id: 4,
        access: "Manage baskets"
    },
    {
        id: 5,
        access: "Manage baskets"
    },
];

const Permissions = (props) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // handle select access 
    const _handleAddAccess = (id) => {
        setSelectedIds((prev) => {
            if (prev.includes(id)) {
                return prev.filter((existing_id) => existing_id !== id);
            }
            return [...prev, id];
        });
    };

    // Admins table column 
    const ACCESS_TABLE_COLUMN = [
        {
            name: '',
            cell: (row) =>
                <div className='d-flex gap-2 align-items-center'>
                    <div>
                        {/* <Icon icon={selectedIds.includes(row.id) ? "checkbox-active" : "checkbox-inactive"}
                            size="1.25rem"
                            className="d-flex"
                            onClick={() => _handleAddAccess(row.id)} /> */}
                    </div>
                    <p className='mb-0 e-text-dark-gray e-primary-font e-font-14 line-height-18px'>
                        {row.name}
                    </p>
                </div>,
            width: "220px"
        },
    ];

    return (
        <Fragment>
            <div className='padding-32px-lr padding-32px-top'>
                <div className='d-flex align-items-center justify-content-between'>
                    <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                        Module Access
                    </h4>
                    {/* 
                    <div className='d-flex gap-40px align-items-center'>
                        <TextButton name="Cancel"
                            className="e-font-16 line-height-20px" />
                        <SecondaryButton name="Save Changes"
                            className="p-3 e-font-16 line-height-20px" />
                    </div> */}
                </div>
            </div>

            {/* Sub admins data table */}
            <div className='e-data-table-wrapper pt-2 pb-5'>
                <CustomDataTable columns={ACCESS_TABLE_COLUMN}
                    data={props.data.permissions}
                    // pagination={ACCESS_DATA.length > 10 ? true : false}
                    // paginationPerPage={10}
                    // paginationTotalRows={ACCESS_DATA.length}
                    noTableHead={true}
                    onChangePage={_handleTablePageChange} />
            </div>
        </Fragment>
    )
}

export default Permissions;
